// Prompt 0454 — Dialog de confirmacion al cerrar el panel con cambios sin guardar.
// Prompt 0456 — Movido a ficha-shared/ para consumo desde puesto-panel + rol-funcional-panel
// sin acoplamiento cruzado entre paneles (regla "modulos estancos" de CLAUDE.md).

import type React from 'react';
import { useI18n } from '../../../../../../i18n';

interface DirtyStateWarningProps {
  open: boolean;
  tabsDirtyLabels: string[];
  onConfirm: () => void;
  onCancel: () => void;
}

export function DirtyStateWarning({
  open,
  tabsDirtyLabels,
  onConfirm,
  onCancel,
}: DirtyStateWarningProps) {
  const { t } = useI18n();
  const adm = (t.structure as Record<string, unknown>)?.admin as
    | Record<string, unknown>
    | undefined;
  const lbl = (adm ?? {}) as Record<string, string>;
  const panel = (lbl.puestoPanel ?? {}) as unknown as Record<string, string>;

  if (!open) return null;

  const mensaje = (
    panel.dirtyWarningMessage ?? 'Tienes cambios sin guardar en {tabs}. Descartarlos?'
  ).replace('{tabs}', tabsDirtyLabels.join(', '));

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div onClick={(e) => e.stopPropagation()} style={cardStyle}>
        <h3 style={{ margin: '0 0 12px', fontSize: 16, fontWeight: 700, color: '#0E243E' }}>
          {panel.dirtyWarningTitle ?? 'Cambios sin guardar'}
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: 13, color: '#374151', lineHeight: 1.5 }}>
          {mensaje}
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button onClick={onCancel} style={btnSecondary}>
            {panel.dirtyWarningCancel ?? 'Volver al panel'}
          </button>
          <button onClick={onConfirm} style={btnDanger}>
            {panel.dirtyWarningDiscard ?? 'Descartar y cerrar'}
          </button>
        </div>
      </div>
    </div>
  );
}

const cardStyle: React.CSSProperties = {
  background: '#fff',
  borderRadius: 12,
  borderTop: '3px solid #DC2626',
  maxWidth: 440,
  width: '90%',
  padding: '24px 28px',
  boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
};

const btnSecondary: React.CSSProperties = {
  padding: '8px 20px',
  background: 'transparent',
  border: '1px solid #D1D5DB',
  borderRadius: 6,
  fontSize: 13,
  cursor: 'pointer',
  fontFamily: 'inherit',
  color: '#374151',
};

const btnDanger: React.CSSProperties = {
  padding: '8px 20px',
  background: '#DC2626',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  fontSize: 13,
  fontWeight: 700,
  cursor: 'pointer',
  fontFamily: 'inherit',
};
